(function () {
    var themeJQuery = window.jQuery;

    if (themeJQuery && themeJQuery.fn && !themeJQuery.fn.acRuntimeErrorFixApplied) {
        var originalFind = themeJQuery.fn.find;
        var originalFilter = themeJQuery.fn.filter;
        var originalSlick = themeJQuery.fn.slick;

        function escapeVariantFilterSelector(selector) {
            return selector.split(',').map(function (part) {
                var trimmed = part.trim();

                if (trimmed.indexOf('.filter-') !== 0) {
                    return part;
                }

                var className = trimmed.slice(1);
                var escapedClassName = themeJQuery.escapeSelector
                    ? themeJQuery.escapeSelector(className)
                    : className.replace(/([^A-Za-z0-9_-])/g, '\\$1');

                return part.replace(trimmed, '.' + escapedClassName);
            }).join(',');
        }

        themeJQuery.fn.find = function (selector) {
            if (typeof selector === 'string' && selector.indexOf('.filter-') !== -1) {
                selector = escapeVariantFilterSelector(selector);
            }

            return originalFind.call(this, selector);
        };

        themeJQuery.fn.filter = function (selector) {
            if (typeof selector === 'string' && selector.indexOf('.filter-') !== -1) {
                selector = escapeVariantFilterSelector(selector);
            }

            return originalFilter.call(this, selector);
        };

        if (typeof originalSlick === 'function') {
            themeJQuery.fn.slick = function () {
                var command = arguments[0];
                var requiresSlickInstance = command === 'slickUnfilter' || command === 'slickFilter' || command === 'refresh';
                var hasUninitializedElement = this.toArray().some(function (element) {
                    return !element.slick;
                });

                if (requiresSlickInstance && hasUninitializedElement) {
                    return this;
                }

                return originalSlick.apply(this, arguments);
            };
        }

        themeJQuery.fn.acRuntimeErrorFixApplied = true;
    }

    if (typeof halo === 'undefined' || !window.jQuery || !halo.initVariantImageGroup || halo.initVariantImageGroup.acEscapesVariantFilters) {
        return;
    }

    var originalInitVariantImageGroup = halo.initVariantImageGroup;

    function escapeClassName(value) {
        if ($.escapeSelector) {
            return $.escapeSelector(value);
        }

        return value.replace(/([!"#$%&'()*+,./:;<=>?@[\^\`{|}~])/g, '\\$1');
    }

    function normalizeVariantFilters($scope) {
        $scope.find('input[data-filter]').each(function () {
            var $input = $(this);

            if ($input.data('acVariantFilterEscaped')) {
                return;
            }

            var filter = $input.data('filter');
            if (typeof filter === 'string' && filter.charAt(0) === '.') {
                $input.data('filter', '.' + escapeClassName(filter.slice(1)));
            }

            var defaultLanguageValue = $input.data('value-default-lang');
            if (typeof defaultLanguageValue === 'string' && defaultLanguageValue.length) {
                $input.data('value-default-lang', escapeClassName(defaultLanguageValue));
            }

            $input.data('acVariantFilterEscaped', true);
        });
    }

    function patchedInitVariantImageGroup($scope, enable) {
        if (enable && document.querySelector('.pwzrswiper-wrapper')) {
            return;
        }

        if (enable && $scope && $scope.find) {
            normalizeVariantFilters($scope);

            var $sliderFor = $scope.find('.productView-for');
            var $sliderNav = $scope.find('.productView-nav');
            if (!$sliderFor.hasClass('slick-initialized') || !$sliderNav.hasClass('slick-initialized')) {
                return;
            }
        }

        return originalInitVariantImageGroup.apply(this, arguments);
    }

    patchedInitVariantImageGroup.acEscapesVariantFilters = true;
    halo.initVariantImageGroup = patchedInitVariantImageGroup;
}());